import { Badge, ScrollArea, Table, Text } from "@mantine/core";
import React from "react";
import { PerformancePostAnalytics } from "../../types/performance_analytics";
import {
  formatBoolean,
  formatCount,
  formatDateTime,
  formatDuration,
  getStatusColor,
  getStatusLabel,
} from "../../pages/performance_analytics/shared";

export default function PerformancePostsTable({
  posts,
  onSelectPost,
  selectedJobId,
  showCustomer = true,
}: {
  posts: PerformancePostAnalytics[];
  onSelectPost?: (post: PerformancePostAnalytics) => void;
  selectedJobId?: string | null;
  showCustomer?: boolean;
}) {
  return (
    <ScrollArea>
      <Table striped highlightOnHover verticalSpacing="sm" horizontalSpacing="sm">
        <thead>
          <tr>
            <th>Post</th>
            {showCustomer ? <th>Cliente</th> : null}
            <th>Criado em</th>
            <th>Status atual</th>
            <th>Ciclo</th>
            <th>Aprovação</th>
            <th>Revisões</th>
            <th>Ajustes</th>
            <th>Aprovado sem ajustes</th>
            <th>Aprovação até agendamento</th>
            <th>Agendamento até publicação</th>
            <th>Atraso</th>
            <th>Post atrasado</th>
          </tr>
        </thead>
        <tbody>
          {posts.map((post) => {
            const selected = selectedJobId === post.jobId;

            return (
              <tr
                key={post.jobId}
                onClick={() => onSelectPost?.(post)}
                style={{
                  cursor: onSelectPost ? "pointer" : "default",
                  backgroundColor: selected ? "#eef6ff" : undefined,
                }}
              >
                <td>
                  <Text fw={600} size="sm">
                    {post.jobName || "Sem nome"}
                  </Text>
                </td>
                {showCustomer ? <td>{post.customerName}</td> : null}
                <td>{formatDateTime(post.createdAt)}</td>
                <td>
                  <Badge color={getStatusColor(post.currentStatusKey)} variant="light">
                    {getStatusLabel(post.currentStatusKey)}
                  </Badge>
                </td>
                <td>{formatDuration(post.totalLifecycleTimeMs)}</td>
                <td>{formatDuration(post.approvalTimeMs)}</td>
                <td>{formatCount(post.revisionsCount)}</td>
                <td>{formatCount(post.changesRequestedCount)}</td>
                <td>{formatBoolean(post.approvedWithoutChanges)}</td>
                <td>{formatDuration(post.approvalToScheduledTimeMs)}</td>
                <td>{formatDuration(post.scheduledToPublishedTimeMs)}</td>
                <td>{formatDuration(post.delayMs)}</td>
                <td>{formatBoolean(post.isDelayed)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </ScrollArea>
  );
}